export default function AlignLeft() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 2H1C0.447812 2 0 1.55219 0 1C0 0.447812 0.447812 0 1 0H8C8.55313 0 9 0.447812 9 1C9 1.55219 8.55313 2 8 2ZM8 10H1C0.447812 10 0 9.55313 0 9C0 8.44687 0.447812 8 1 8H8C8.55313 8 9 8.44687 9 9C9 9.55313 8.55313 10 8 10ZM0 5C0 4.44687 0.447812 4 1 4H13C13.5531 4 14 4.44687 14 5C14 5.55313 13.5531 6 13 6H1C0.447812 6 0 5.55313 0 5ZM13 14H1C0.447812 14 0 13.5531 0 13C0 12.4469 0.447812 12 1 12H13C13.5531 12 14 12.4469 14 13C14 13.5531 13.5531 14 13 14Z" fill="currentColor" />
    </svg>
  )
}
